import React, { useState } from 'react';
import ReactTable from 'react-table'
import ReactTooltip from 'react-tooltip'
import moment from 'moment';
import Select from 'react-select';
import Modal from '../../../components/molecules/Modal';
import { createWebhook, deleteWebhook } from '../../../store/action/webhook';

const WebhookTable = props => {
    const [ testData, setTestData ] = useState(localStorage.getItem('biteship_test_data')||'notActive') 
    const [ modalShow, setModalShow ] = useState(false);
    const [ loadingCreateWebhook, setLoadingCreateWebhook ] = useState(false);
    const [ selectedWebhookEvents, setSelectedWebhooksEvents ] = useState([]);
    const webhookOptions = [{
        label:'order.status',
        value:'order.status'
    },
    {
        label:'order.price',
        value:'order.price'
    },
    {
        label:'order.waybill_id',
        value:'order.waybill_id'
    }]

    const [ webhook, setWebhook ] = useState({
        name:'',
        description:'',
        url:'',
        signatureKey:'',
        signatureSecret:''
    })
    const columns = [{
        Header: 'NAMA',
        headerClassName: 'pl-4',
        minWidth: 120,
        Cell: ({row,original}) => nameCell(original)
    },{
        Header: 'URL',
        accessor: 'url',
    },{
        Header: 'EVENTS',
        accessor: 'events',
        Cell: ({row,original}) => eventCell(original)
    },{
        Header: 'TANGGAL DIBUAT',
        accessor: 'createdAt',
        minWidth: 80,
        Cell: ({row,original}) => createdCell(original) 
    },{
        Header: 'EDIT',
        accessor: 'edit',
        minWidth: 30,
        Cell: ({row,original}) => editCell(original)
    }];

    const nameCell = (og) => {
        return (
            <div className="pl-4 pointer">
                <text className="font-weight-bold text-darker">{og.name}</text> <br/>
                <text>{og.description}</text>
                { 
                    og.id ?  <div>ID Webhook: <b>{og.id}</b></div> : null
                }
                
            </div>
        )
    };

    const createdCell = (og) => {
        if (og.created_at) {
            return (
                <div className="pointer">{moment(og.created_at).format("DD MMM YYYY, HH:mm")}</div>
            )
        } else {
            return "Tidak Ada"
        }
    }
    const eventCell = (og) => {
        return (
            <div className="pointer row pl-4">
                {
                    og.events.map(i => (
                        <div className="mr-2">
                            <span className={`badge ${testData === 'active' ? 'badge-warning' : 'badge-info'}`}>
                                {i}
                            </span>
                        </div>

                    ))
                }              
            </div>
        )
    };

    const editCell = (og) => {
        return (
            <div className="actions row ml-1 pointer">
                <ReactTooltip/>
                <a onClick={() => onRemoveWebhook(og.id)}
                   className="action-item mr-2"
                   data-toggle="tooltip"
                   data-tip="Buang Kunci "
                   title="Trash"
                >
                    <i className="fas fa-trash"></i>
                </a>
            </div>
        )
    };

    const onChangeWebhook = (e) => {
        setSelectedWebhooksEvents(e)
    };

    
    const onRemoveWebhook = async (id) => {
        if (window.confirm("Apakah Anda yakin mau hapus webhook?")) { 
            const res = await deleteWebhook(id);
            if (!res.success) {
                alert(res.error);
                return
            }
            alert(`Webhook berhasil dihapus`);
            window.location.reload()
        }
    };

    const onAddWebhook = async () => {
        const selectedEvents = selectedWebhookEvents.reduce((r,i) => {
            r.push(i.value);
            return r;
        },[])
        const data = {
            name:webhook.name,
            description:webhook.description,
            url:webhook.url,
            environment:testData === 'active' ? 'test' : 'live',
            events:selectedEvents,
            signature_key:webhook.signatureKey,
            signature_secret:webhook.signatureSecret
        }
        
        const res = await createWebhook(data);
        if (!res.success) {
            alert(res.error);
            return
        }
        alert(`Webhook berhasil ditambah`);
        window.location.reload()
    }


    const modal = () => {
        return (
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                title={"Buat Webhook"}
                size={"md"}
                bodyClassName="px-4 pt-4 pb-2"
                buttons
                type='oneButton'
                bText={"Buat Baru"}
                loading={loadingCreateWebhook}
                bClick={() => onAddWebhook()}
            >
                <div className="form">
                    <div className="form-group input-group-sm">
                        <h6>Detail</h6>
                        <input
                            type="text"
                            onChange={e => setWebhook({...webhook,['name']:e.target.value})}
                            placeholder="Nama Webhook"
                            className="form-control mb-4"
                            value={webhook.name}
                            required
                        />
                        <textarea
                            type="text"
                            onChange={e => setWebhook({...webhook,['description']:e.target.value})}
                            placeholder="Deskripsi Webhook (optional)"
                            style={{height:80}}
                            className="form-control mb-4"
                            value={webhook.description}
                            required
                        />
                        <input
                            type="text"
                            onChange={e => setWebhook({...webhook,['url']:e.target.value})}
                            placeholder="URL Webhook"
                            className="form-control mb-4"
                            value={webhook.url}
                            required
                        />
                        <Select
                            isMulti
                            value={selectedWebhookEvents}
                            onChange={e => onChangeWebhook(e)}
                            options={webhookOptions}
                            placeholder="Masukkan list event webhook"
                        />
                        <h6 className="mt-4">Headers (Optional)</h6>
                        <input
                            type="text"
                            onChange={e => setWebhook({...webhook,['signatureKey']:e.target.value})}
                            placeholder="Headers Signature Key"
                            className="form-control mb-4"
                            value={webhook.signatureKey}
                            required
                        />
                        <input
                            type="text"
                            onChange={e => setWebhook({...webhook,['signatureSecret']:e.target.value})}
                            placeholder="Headers Signature Secret"
                            className="form-control mb-4"
                            value={webhook.signatureSecret}
                            required
                        />
                    </div>
                </div>
            </Modal>
        )
    };

    return (
        <div className="bg-white rounded shadow">
            { modal() }

            <div className="p-4 d-flex justify-content-between">
                <h5>Webhook</h5>
                {
                    props.data.length === 0 ? null :
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={() => setModalShow(true)}
                    >
                        Tambah Webhook
                    </button>
                }
              
            </div>

            {
                props.data.length === 0 ? 
                <div className="text-center mt-4 pb-5">
                    <h4>Anda belum daftarkan Webhook</h4>
                    <p>Generate webhook baru!</p>
                    <button
                        onClick={() => setModalShow(true)}
                        className="btn btn-primary col-3 mt-2">
                        Daftarkan Webhook
                    </button>
                </div>
                :
                <ReactTable
                    data={props.data}
                    columns={columns}
                    defaultPageSize={props.data.length}
                    loading={props.loading}
                    showPagination={false}
                    className="-striped -highlight"
                />
            }
            
        </div>
    )
};

export default WebhookTable;
